import PhotoSwipeLightbox from '../vendor/photoswipe/photoswipe-lightbox.esm'
import PhotoSwipe from '../vendor/photoswipe/photoswipe.esm'
;(async () => {
    const options = {
        gallerySelector: '.vp-block-image',
        childSelector: 'figure picture a',
        pswpModule: PhotoSwipe,
    }

    const lightbox = new PhotoSwipeLightbox(options)
    lightbox.init()
})()
